import { message, Row, Col } from "antd";
import axios from "axios";
import { Divider } from "rc-menu";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import PermisosEditor from "../../PermisosEditor";

class AgregarPerfil extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    permisosValues: [],
  };

  cerrarAgregarPerfil(codigo) {
    this.props.cerrarAgregarPerfil(codigo);
  }

  // ---- Modelo de valor para PermisosEditor ----

  getEstadoPermiso = (id) => {
    const pv = this.state.permisosValues.find((p) => p.permisoId === id);
    return pv
      ? { activado: pv.activado, valor: pv.valor }
      : { activado: false, valor: null };
  };

  onToggleVarios = (ids, checked) => {
    const permisosValues = [...this.state.permisosValues];
    ids.forEach((id) => {
      const i = permisosValues.findIndex((p) => p.permisoId === id);
      if (i === -1) {
        permisosValues.push({ permisoId: id, activado: checked, valor: null });
      } else {
        permisosValues[i] = { ...permisosValues[i], activado: checked };
      }
    });
    this.setState({ permisosValues });
  };

  onChangeValor = (id, valor) => {
    const permisosValues = [...this.state.permisosValues];
    const i = permisosValues.findIndex((p) => p.permisoId === id);
    if (i === -1) {
      permisosValues.push({ permisoId: id, activado: false, valor });
    } else {
      permisosValues[i] = { ...permisosValues[i], valor };
    }
    this.setState({ permisosValues });
  };

  // ---- Submit ----

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "perfiles/agregarPerfil",
        {
          ...values,
          permisos: this.state.permisosValues,
          usuarioPrincipal: this.props.usuarioPrincipal,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado un perfil");
          this.formRef.current.resetFields();
          this.setState({ permisosValues: [] });
          this.cerrarAgregarPerfil(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error("No se puede registrar el perfil");
        } else {
          message.error("Hubo un error y el perfil no se registro");
        }
      });
  }

  cerrarModalAgregarPerfil() {
    this.formRef.current.resetFields();
    this.setState({ loading: false, permisosValues: [] });
    this.cerrarAgregarPerfil();
  }

  render() {
    return (
      <>
        <ModalItem
          title="Agregar Perfil"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarModalAgregarPerfil.bind(this)}
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="agregarPerfil"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Agregar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Row>
              <Col span={12}>
                <FormItem
                  name="nombre"
                  label="Nombre"
                  required
                  max={100}
                  margin
                  pattern
                >
                  <InputItem placeholder="Nombre" />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  name="descripcion"
                  label="Descripcion"
                  required
                  max={100}
                  margin
                  pattern
                >
                  <InputItem placeholder="Descripcion" />
                </FormItem>
              </Col>
            </Row>
            <Divider
              style={{ marginBottom: 10, marginTop: 5 }}
              children="Permisos"
            />
            <PermisosEditor
              headersToken={this.props.headersToken}
              tipo={this.props.tipo}
              usuarioPrincipal={this.props.usuarioPrincipal}
              getEstadoPermiso={this.getEstadoPermiso}
              onToggleVarios={this.onToggleVarios}
              onChangeValor={this.onChangeValor}
              mostrarSeleccionarTodos
            />
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioPrincipal: state.user.usuarioPrincipal,
    empresaId: state.empresa.id,
    tipo: state.user.tipo,
  };
};

export default connect(mapStateToProps)(AgregarPerfil);
